module.exports = __webpack_public_path__ + "img/vk.84064f4.svg";